import classNames from 'classnames'
import React from 'react'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'
import { type IconName } from '~/utils'

import styles from './IconButton.css'

export type IconButtonProps = Omit<StyledButtonProps, 'children' | 'icon'> & {
  icon: IconName
}

export const IconButton = ({
  className,
  'data-testid': dataTestId = 'components-elements-icon-button',
  icon,
  ...rest
}: IconButtonProps) => (
  <StyledButton
    className={classNames(styles.root, className)}
    data-testid={dataTestId}
    icon={icon}
    {...rest}
  />
)
